import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
export function Experimental__IconCheck(props) {
  var iconList = [{
    "size": 16,
    "svgContent": "<path d=\"M13.985 2.383L5.127 12.754 1.388 8.375l-.658.77 4.397 5.149 9.618-11.262z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M21.848 3.671L8.021 19.859l-5.928-6.94-.657.77 6.585 7.71L22.608 4.32z\"/>"
  }, {
    "size": 32,
    "svgContent": "<path d=\"M29.373 5.118L11 26.63l-7.93-9.285-.657.769L11 28.169 30.133 5.768z\"/>"
  }, {
    "size": 48,
    "svgContent": "<path d=\"M44.103 7.128L16.45 39.505 4.594 25.623l-1.315 1.54L16.45 42.585 45.624 8.427z\"/>"
  }, {
    "size": 64,
    "svgContent": "<path d=\"M57.347 9.916L22.628 50.567 7.66 33.042l-1.315 1.54 16.283 19.064 36.24-42.431z\"/>"
  }];
  var iconListRedraw = [{
    "size": 16,
    "svgContent": "<path d=\"M15.53 2.47a.75.75 0 010 1.06L4.907 14.153.47 9.716a.75.75 0 011.06-1.06l3.377 3.376L14.47 2.47a.75.75 0 011.06 0z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M21.707 4.805a1 1 0 010 1.414L8.024 19.902l-5.731-5.73a1 1 0 111.414-1.415l4.317 4.317L20.293 4.805a1 1 0 011.414 0z\"/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.next ? iconListRedraw : iconListFallback, props.iconSize || 24);
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: closestSize.svgContent
    }
  }));
}
export default Experimental__IconCheck;